import type { ResponsiveVariants } from "shared/lib/styles";

import type { AppBarVariant } from "scmp-app/components/app-bar/types";
import type { HomeResponsiveFeature } from "scmp-app/components/home/header/types";

import type { ActionButtonProps } from "./styles";

export type Feature =
  | "article-speech"
  | "content-bookmark"
  | "content-comment"
  | "content-share"
  | "dashboard"
  | "hamburger-menu"
  | "logo-link"
  | "logo-link-style"
  | "my-news"
  | "newsletter"
  | "search"
  | "subscription"
  | "text-link-style";

export const PositionVariants = ["left", "right"] as const;

export type FeatureConfiguration = {
  isEnabled: boolean;
  responsiveVariants: ActionButtonProps["$responsiveVariants"];
};

export type HeaderConfiguration = {
  appBarStickyScrollHeight?: number;
  appBarVariant?: AppBarVariant;
  homeResponsiveFeatures?: HomeResponsiveFeature;
  responsiveFeatures?: ResponsiveFeature;
};

export type PositionVariant = (typeof PositionVariants)[number];

export type PositionVariantToFeatureConfiguration = Record<PositionVariant, FeatureConfiguration>;

export type ResponsiveFeature = Partial<
  ResponsiveVariants<{
    default: PositionVariantToFeatures;
    nonSubscriberSwapped?: PositionVariantToFeatures;
    swapped?: PositionVariantToFeatures;
  }>
>;

type PositionVariantToFeatures = {
  left: Array<Exclude<Feature, "article-speech">>;
  right: Array<Feature>;
};
